/* eslint-disable react/button-has-type */
import React, { useRef } from 'react';
import CanvasDraw from 'react-canvas-draw';

import { applyPainMapDotFix } from '@mummssoftware/utils/utils';

import painMapGif from '../images/pain.gif';

type PainMapReadOnlyProps = {
  subqchoice: any;
};

export const PainMapReadOnly = ({ subqchoice }: PainMapReadOnlyProps) => {
  const canvasRef = useRef<any>(null);
  // CanvasDraw expects a string
  const savedData =
    subqchoice?.value && subqchoice?.value !== 'false'
      ? JSON.stringify(subqchoice.value)
      : undefined;

  return (
    <div id="read-only-pain-map">
      <CanvasDraw
        disabled
        imgSrc={painMapGif}
        ref={(canvasDraw) => {
          canvasRef.current = canvasDraw;
          applyPainMapDotFix(canvasDraw);
        }}
        canvasWidth={600}
        canvasHeight={245}
        saveData={savedData}
      />
    </div>
  );
};
